import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Warning = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" {...props}>
    <path d="M11 14V8.50001H13V14H11Z" fill="currentColor" />
    <path d="M11 17.5V15.5H13V17.5H11Z" fill="currentColor" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.2557 3.60939L2.17088 18.0215C1.423 19.3547 2.38654 21 3.91517 21H20.0849C21.6135 21 22.577 19.3547 21.8291 18.0215L13.7443 3.60939C12.9803 2.24739 11.0198 2.24739 10.2557 3.60939ZM3.91517 19L12 4.58789L20.0849 19L3.91517 19Z"
      fill="currentColor"
    />
  </Icon>
));

export default Warning;
